/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PrebidImportBufferReason {
  AuctionNotResolvable = 'auction_not_resolvable',
  LotNotFound = 'lot_not_found',
  AmbiguousLotNumber = 'ambiguous_lot_number',
  CurrencyMismatch = 'currency_mismatch',
  AmountNotAlignedToBidIncrements = 'amount_not_aligned_to_bid_increments',
  BidderNotProvisionable = 'bidder_not_provisionable'
}
